"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/CYFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_57)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_57`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.94389 10.8561C3.94389 10.8561 3.95793 15.5649 9.186 15.4386L9.50179 16.414H10.1263C10.1263 16.414 9.60705 13.5298 14.3439 13.5017C14.3439 13.5017 14.3439 11.5649 16.2807 11.5649H19.193C19.193 11.5649 14.5614 7.92978 23.3263 3.28417L23.4527 2.36487C23.4527 2.36487 14.3369 7.34732 9.49477 6.3789C9.49477 6.3789 10.2456 9.36136 8.73688 9.36136C7.97898 9.36136 8.05617 8.79294 6.47021 8.79294C5.15793 8.79294 5.25617 10.1754 4.62459 10.1614C4.00003 10.1473 3.3053 9.2982 3.24916 9.44557C3.20003 9.59294 3.94389 10.8561 3.94389 10.8561Z",
					fill: "#DB7D00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.6458 21.621C11.13 21.2701 11.558 21.1578 12.2177 21.0385C12.8773 20.9192 13.5791 20.7298 13.944 20.6315C14.3089 20.5333 12.7019 21.0947 12.2949 21.214C11.8879 21.3263 10.6458 21.621 10.6458 21.621ZM13.3054 20.5894C13.1721 19.7543 13.5019 18.8841 14.2528 18.5333C14.4282 19.1368 13.8879 20.1613 13.3054 20.5894ZM14.5826 20.1543C14.1756 19.4666 14.8633 18.5684 15.3615 18.1333C15.5931 18.5543 15.1861 19.7964 14.5826 20.1543ZM15.7686 19.621C15.3335 19.0315 15.8458 17.9929 16.3861 17.5859C16.6036 18.1613 16.3931 19.214 15.7686 19.621ZM16.9545 18.8771C16.5615 18.3157 16.8352 17.4456 17.3966 16.8841C17.8036 17.3473 17.4598 18.3578 16.9545 18.8771ZM17.9019 18.1263C17.5721 17.5999 17.9791 16.3438 18.5054 15.9929C18.737 16.4561 18.5615 17.7754 17.9019 18.1263ZM18.6598 17.9298C18.5615 17.1719 19.8808 16.3368 20.4282 16.3578C20.3651 16.9824 19.8036 17.6631 18.6598 17.9298ZM17.9229 18.7859C18.5405 18.1473 19.7475 18.1473 20.1756 18.2806C20.0563 18.6526 18.6387 19.4666 17.9229 18.7859Z",
					fill: "#006651"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.0668 19.4245C17.9369 19.1929 18.5054 18.9964 19.0247 19.5438C18.6597 20.007 17.2422 19.8736 17.0668 19.4245ZM15.8247 19.9859C16.6597 19.5368 17.6703 20.1964 17.8247 20.5894C16.8913 20.9754 15.8106 20.0841 15.8247 19.9859ZM14.6808 20.6315C15.4387 20.3438 16.3089 20.7298 16.6597 21.1578C16.2527 21.3473 15.1861 21.5578 14.6808 20.6315ZM13.6352 20.9613C14.5054 20.8631 15.3475 21.5227 15.5299 21.9017C14.4141 22.007 13.9861 21.6771 13.6352 20.9613ZM13.3545 21.621C12.8703 21.2701 12.4422 21.1578 11.7825 21.0385C11.1229 20.9192 10.4211 20.7298 10.0562 20.6315C9.6843 20.5333 11.2983 21.0947 11.7054 21.214C12.1124 21.3263 13.3545 21.621 13.3545 21.621ZM10.6948 20.5894C10.8282 19.7543 10.4983 18.8841 9.74746 18.5333C9.57202 19.1368 10.1124 20.1613 10.6948 20.5894ZM9.41764 20.1543C9.82465 19.4666 9.13693 18.5684 8.63869 18.1333C8.40711 18.5543 8.81413 19.7964 9.41764 20.1543ZM8.23167 19.621C8.66676 19.0315 8.15448 17.9929 7.61413 17.5859C7.39658 18.1613 7.60711 19.214 8.23167 19.621ZM7.04571 18.8771C7.43869 18.3157 7.165 17.4456 6.6036 16.8841C6.19658 17.3473 6.54044 18.3578 7.04571 18.8771ZM6.09834 18.1263C6.42816 17.5999 6.02114 16.3438 5.49483 15.9929C5.26325 16.4561 5.43869 17.7754 6.09834 18.1263ZM5.34044 17.9298C5.43869 17.1719 4.11939 16.3368 3.57202 16.3578C3.63518 16.9824 4.19658 17.6631 5.34044 17.9298ZM6.07729 18.7859C5.45974 18.1473 4.25272 18.1473 3.82465 18.2806C3.94395 18.6526 5.3615 19.4666 6.07729 18.7859Z",
					fill: "#006651"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.93348 19.4244C6.06331 19.1929 5.49488 18.9964 4.97559 19.5437C5.3405 20.0069 6.75804 19.8736 6.93348 19.4244ZM8.17559 19.9859C7.3405 19.5367 6.32997 20.1964 6.17559 20.5894C7.10892 20.9753 8.18962 20.0841 8.17559 19.9859ZM9.31945 20.6315C8.56155 20.3437 7.69138 20.7297 7.3405 21.1578C7.74752 21.3473 8.81418 21.5578 9.31945 20.6315ZM10.3651 20.9613C9.49488 20.863 8.65278 21.5227 8.47032 21.9016C9.58611 22.0069 10.0142 21.6771 10.3651 20.9613Z",
					fill: "#006651"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_57`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as CYFlag };
